@if ((isDisplayed$ | async) && data.description; as description) {
  <section class="text-seo">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-xs-12">
          <div [innerHTML]="description" [ngClass]="{ hidden: isHidden() }" class="text"></div>
          <div class="action">
            <button (click)="isHidden.set(!isHidden())" class="btn btn-link">
              @if (isHidden()) {
                <span>{{ data.open }}</span>
              }
              @if (!isHidden()) {
                <span>{{ data.close }}</span>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
}
